export default __webpack_public_path__ + "static/media/seLigaBanner.0d5585d9.jpg";